import apiClient from '../api';

export const createTextToSpeech = (data) => apiClient.post('/ttsopenai/generate-audio', data);
export const getVODetailByProjectId = (projectId) => apiClient.get(`/ttsopenai/${projectId}`);